<template>
  <div class="short-info-siembiot-ad text-center">
    <div v-on:click="dataSquidex?.cardVisibleText ? (showAdWindow = !showAdWindow) : null" class="btn-siembiot-ad" >
      <span class="d-block text-white mb-2 fs-16" v-if="dataSquidex?.cardVisibleText">{{ dataSquidex?.cardVisibleText }}</span>
      <LoaderSimebiotCard v-else></LoaderSimebiotCard>
      <img src="@/assets/images/logo.webp" />
    </div>
  </div>

  <div v-if="showAdWindow" class="siembiot-ad-bg" v-on:click="showAdWindow = !showAdWindow"></div>

  <div v-show="showAdWindow" class="siembiot-ad-card">
    <!-- {{ dataSquidex }} -->
    <div class="mb-4 section1 p-30">
      <span class="siembiotAdComponentCloseBtn" v-on:click="showAdWindow = !showAdWindow">X</span>
      <div class="row">
        <div class="col-12 col-md-7 mb-3 pe-0">
          <img width="130" class="mb-4" src="@/assets/images/small-siembiot-logo.webp" />
          <h2 class="mb-3 fw-medium">{{ dataSquidex?.title }}</h2>
          <span>{{ dataSquidex?.text1 }}</span>
          <div class="row mt-3">
            <div class="col-auto mb-3">
              <a
                class="btn btn-blue-siembiot"
                :href="dataSquidex?.link1"
                type="button"
                target="_blank"
                >{{ dataSquidex?.btnBlueText }}
              </a>
            </div>
            <div class="col-auto mb-3">
              <a
                class="btn btn-outline-light"
                :href="dataSquidex?.link2"
                type="button"
                target="_blank"
                >{{ dataSquidex?.btnOutlineText }}</a
              >
            </div>
          </div>
        </div>

        <div class="col mb-3 p-0 position-relative"></div>
      </div>

      <p>
        {{ dataSquidex?.text2 }}
      </p>
    </div>

    <div class="p-30 pb-0 pt-0">
      <h4 class="mb-3 fw-medium">
        {{ dataSquidex?.title2 }}
      </h4>
      <p class="mb-3">
        {{ dataSquidex?.text3 }}
      </p>
    </div>

    <div class="row p-30 pt-0">
      <!-- {{  dataSquidex?.items}} -->
      <div class="col-12 col-md-6 mt-3" v-for="item in dataSquidex?.items" :key="item">
        <div class="card siembiot-card">
          <div class="card-body">
            <!-- {{ item.data }} -->
            <div class="row">
              <div class="col-auto">
                <img width="40" :src="$utils.ShowDynamicImage(item?.data?.iconImage)" />
              </div>
              <div class="col">
                <p>{{ item?.data?.titleSimple }}</p>
                <small></small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useTypewriter } from '@/utils/useTypewriter'
import { getSiembiotCardQuery } from '@/graphs/siembiotCardGraph'
import LoaderSimebiotCard from '../Others/loaders/LoaderSimebiotCard.vue';
export default {
  name: 'Surveys',

  data() {
    return {
      dataSquidex: null,
      showAdWindow: false,
    }
  },
  components:{
    LoaderSimebiotCard,
  },
  methods: {
    async GetHomeDataSquidex() {
      const lang = this.$utils.getCookie()
      const query = getSiembiotCardQuery(lang)
      await this.$axios
        .post(`/api/Squidex/postGraphQLAsync`, query)
        .then((response) => {
          const raw = response.data?.data?.findSiembiotCardBottomRightSingleton?.data
          //remove language
          let cleanData = this.$utils.removeLocaleDeep(raw, lang)
          cleanData = this.$utils.transformImageFields(cleanData)
          this.dataSquidex = cleanData
        })
        .catch((error) => {
          this.$utils.ToastNotifySomethingWentWrong()
        })
    },
  },
  created() {
    this.GetHomeDataSquidex()
  },
}
</script>

<style scoped>
.siembiotAdComponentCloseBtn {
  color: white;
  position: absolute;
  right: 20px;
  top: 20px;
  background: #131b28;
  width: 40px;
  height: 40px;
  padding: 10px;
  text-align: center;
  border-radius: 10px;
  font-weight: 600;
  z-index: 2;
  cursor: pointer;
  transition-duration: 0.5s;
  border: 1px solid #ffffff2e;
}

.siembiotAdComponentCloseBtn:hover {
  background: #f8f9fa45;
  transition-duration: 0.5s;
}

.fs-16 {
  font-size: 16px;
}

.p-30 {
  padding: 30px;
}

.siembiot-ad-card {
  background: linear-gradient(112.08deg, #273246, #0e141f);
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  max-width: 800px;
  right: 0;
  bottom: 0;
  color: white;
  border-top-left-radius: 15px !important;
  z-index: 500;
  text-align: left;
  border-radius: 10px;
  overflow: hidden;
  max-height: 100vh;
  overflow-y: auto;
}

h4 {
  font-size: 1.5rem !important;
}

.siembiot-card {
  border-radius: 10px;
  background: #252c3c85;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
  border: 1px solid #ffffff2e;
}

.btn-blue-siembiot {
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-size: var(--bs-btn-font-size);
}

.siembiot-ad-bg {
  background: linear-gradient(112.08deg, #273246ba 0%, #0e141f57 100%);
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 400;
}

.nis2-img {
  width: 538px;
  position: absolute;
  left: -146px;
  top: -26px;
}

.section1 {
  background: url('/src/assets/images/siembiot-ad/top-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  min-height: 430px;
  background-position: 0px -31px;
  overflow: hidden;
  position: relative;
}

.section1::after {
  background: linear-gradient(44deg, #242e40 0%, #1d232f 100%);
  content: '';
  height: 20px;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  border-top: 5px solid #28303e;
}

.short-info-siembiot-ad {
  z-index: 300;
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.btn-siembiot-ad {
  cursor: pointer;

  background: #14181fd1;
  padding: 25px;
  border-radius: 20px;
  transition-duration: 0.5s;
}

.btn-siembiot-ad:hover {
  background: #14181f;
  transition-duration: 0.5s;
}

.btn-siembiot-ad img {
  width: 200px;
}

.typewriter {
  width: 100px;
  display: block;
  align-items: center;
  white-space: pre;
  color: #000000a9;
  /* background: #000000a9; */
}

.cursor {
  margin-left: 2px;
}

.blink {
  animation: blink 0.9s steps(1) infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

template {
  display: block;
}
</style>
